import BackgroundLights from "./BackgroundLights";
import LettuceThinkingLogo from "../../../images/lettuce-thinking.png";

function CreatingCardScreen() {
  return (
    <div className="relative mx-auto flex w-full max-w-lg items-center justify-center text-center px-8 h-full">
      <BackgroundLights showFieldAura={false} />
      <div className="refine-loading-glow pointer-events-none absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 -translate-y-[58%] rounded-full bg-[radial-gradient(circle,rgba(244,217,78,0.56)_0%,rgba(255,248,218,0.34)_34%,rgba(106,174,37,0.16)_58%,transparent_74%)] blur-2xl sm:h-72 sm:w-72" />

      <div className="relative z-10 flex flex-col items-center">
        <div className="relative h-32 w-32">
          <img
            src={LettuceThinkingLogo}
            alt="LettuceTalk"
            className="refine-loading-logo absolute bottom-0 left-1/2 h-32 w-32 -translate-x-1/2 object-contain drop-shadow-[0_18px_24px_rgba(244,217,78,0.22)]"
          />
        </div>

        <h1 className="mx-auto mt-4 max-w-md font-serif text-3xl font-medium text-white drop-shadow-[0_0_30px_rgba(255,255,255,0.12)] sm:text-5xl">
          Finding the gentle question inside your words...
        </h1>

        <div className="mt-6 w-full max-w-[14rem] sm:mt-7 sm:max-w-[16rem]">
          <div
            role="progressbar"
            aria-label="Creating your card"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuetext="Creating your card; progress is approximate"
            className="relative h-2 w-full overflow-hidden rounded-full border border-white/20 bg-white/10 shadow-[0_0_20px_rgba(244,217,78,0.14),inset_0_1px_0_rgba(255,255,255,0.18)]"
          >
            <span className="refine-loading-progress-fill absolute inset-y-0 left-0 w-[18%] rounded-full bg-[linear-gradient(90deg,rgba(121,183,62,0.94)_0%,rgba(244,217,78,0.98)_56%,rgba(255,248,218,0.98)_100%)] shadow-[0_0_14px_rgba(244,217,78,0.32)]" />
            <span
              aria-hidden="true"
              className="refine-loading-progress-sheen absolute inset-y-[-2px] left-0 w-10 rounded-full bg-white/55 blur-sm"
            />
            <span
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 rounded-full shadow-[inset_0_0_8px_rgba(255,255,255,0.14)]"
            />
          </div>
        </div>
      </div>

      <style>{`
        .refine-loading-logo {
          animation: refine-loading-logo-breathe 3s ease-in-out infinite;
        }

        .refine-loading-glow {
          animation: refine-loading-glow-breathe 3.8s ease-in-out infinite;
        }

        .refine-loading-progress-fill {
          animation: refine-loading-progress-fill 18s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }

        .refine-loading-progress-sheen {
          animation: refine-loading-progress-sheen 3.2s ease-in-out infinite;
        }

        @keyframes refine-loading-logo-breathe {
          0%, 100% { transform: translateX(-50%) translateY(0) scale(1); }
          50% { transform: translateX(-50%) translateY(-6px) scale(1.04); }
        }

        @keyframes refine-loading-glow-breathe {
          0%, 100% { opacity: 0.78; transform: translate(-50%, -58%) scale(0.92); }
          50% { opacity: 0.98; transform: translate(-50%, -58%) scale(1.04); }
        }

        @keyframes refine-loading-progress-fill {
          0% { width: 18%; }
          28% { width: 42%; }
          58% { width: 68%; }
          100% { width: 86%; }
        }

        @keyframes refine-loading-progress-sheen {
          0% { opacity: 0; transform: translateX(-5rem); }
          24% { opacity: 0.38; }
          64% { opacity: 0.16; }
          100% { opacity: 0; transform: translateX(22rem); }
        }

        @media (prefers-reduced-motion: reduce) {
          .refine-loading-logo,
          .refine-loading-glow,
          .refine-loading-progress-fill,
          .refine-loading-progress-sheen {
            animation: none !important;
          }

          .refine-loading-progress-fill {
            width: 64%;
          }

          .refine-loading-progress-sheen {
            opacity: 0.16;
            transform: translateX(9rem);
          }
        }
      `}</style>
    </div>
  );
}

export default CreatingCardScreen;
